var cell_default = {
  "cell": "_3h8LY",
  "header": "_4mRxq",
  "selected": "qhjKy",
  "editing": "egp-e",
  "singleSelection": "ZPN8K",
  "hideLastBlock": "lXRQn",
  "editorWrapper": "_0htkH",
  "viewerWrapper": "hX27Q",
  "hideFirstBlock": "_5Z-AQ",
  "editor": "C5Xuq",
  "edit": "OLx7j",
  "view": "yZeRK",
  "editingToolbarWrapper": "pyfKL",
  "selectAll": "kErS2",
  "disableSelection": "b7MRE"
};
export {
  cell_default as default
};
//# sourceMappingURL=cell-scss.js.map
